import Action from '../Action'
// import './styles/ImportInfo.css'../../
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import SelectorIcons from '../SelectorIcons';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import { importFunction } from '../../utils/utils';
import Search from "../generales/Search";
import Paginador from "../generales/Paginador";
import InputForm from '../generales/InputForm';
import { use } from 'react';
import Modal from "react-modal";
import ModalAddCIs from './ModalAddCIs';
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'80%',
    height:'70%',
    padding:'20px'
  },
};
const UpdateCisTable =({poolObjectRows,setPoolRows,setPoolObjectRows,datacis,poolRows,users_catalog, handleShowPopup,buscar_auths,buscar_folios,buscar_cis,server,languaje,mode,importLoading,closeImportModal,setImportLoading})=>{
  const [file, setFile] = useState(null);
  const [disabled,setDisabled]=useState(true)
  const [msgError,setMsgError]=useState('texto prueba de error texto prueba de error texto prueba de errortexto prueba de error')
  const [boolError,setBoolError]=useState(false)
  const [response,setResponse]=useState([])
  const [fileContent, setFileContent] = useState(null);
  const field_catalog=useFetch('cassia/cis_v2/mass_update/field/options','','','GET',server)
  const services_catalog=useFetch('cassia/cis_v2/services_catalog','','','GET',server)
  const groups_catalog=useFetch('cassia/cis_v2/groups','','','GET',server)
  const location_catalog=useFetch('zabbix/groups/municipios','','','GET',server)
  const brands_catalog=useFetch('cassia/brands','','','GET',server)
  const models_catalog=useFetch('cassia/host_models','','','GET',server)
  const [tableData, setTableData] = useState([]);


  //     console.log(response)
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  var dataList = searchTerm === "" ? poolObjectRows : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const fileInputRef = useRef(null);
  const [cisData,setCisData]=useState({
          request_user:"",
          auth_user:"",
          user_comment:"",
          value:""
      })
  const [fieldService,setFieldService]=useState("")
  const [dataOptions,setDataOptions]=useState([])
  const [titleOption,setTitleOption]=useState("")
  const [field_id,setField_id]=useState(0)
  const handleFileClick = () => {
    fileInputRef.current.click(); // Simula el clic en el input file oculto
  };
  // // Función para manejar la selección de archivo
  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]);
  // };
  const [doc_id ,setDocid]=useState(0)
  const [loadingDownload,setLoadingDownload]=useState(false)
  const handledownloadDocClick=()=>{
   
           setLoadingDownload(true)
   const fetchDataPost = async () => {
     // console.log(server.url+'/api/v1/cassia/cis_v2/{ci_id}/documents/'+elemento.id+'/download')
  try {
    const response = await fetch(server.url+'/api/v1/cassia/cis_v2/excel_template/update', {
   
      method: 'GET',  
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
    if (response.ok) {
        try {
          const response_data = await response.blob();

          // Crear un enlace para descargar el archivo
          const url = window.URL.createObjectURL(response_data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download','plantilla_cis'); // Cambia el nombre y la extensión del archivo
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoadingDownload(false)
          handleShowPopup('Completado','Archivo descargado correctamente','', true)
        } catch (error) {
            console.error('Error al descargar el archivo', error);
          }
      
    //   setResponseDetail({text:data1.message,value:true})
    //   const timer = setTimeout(() => {
    //       setResponseDetail({text:'',value:true})
    //     }, 2000);
        
    } else {
      throw new Error('Error en la solicitud');
    }
  } catch (error) {
       
       console.error(error);
     }
   };

   fetchDataPost();
  }

  // Función para manejar la importación
  const handleImport = async () => {
      setResponse([])
    // if (!file) {
    //   alert('Por favor selecciona un archivo');
    //   return;
    // }

//     const formData = new FormData();
//     formData.append('file', file); // Agregamos el archivo seleccionado al FormData
// formData.append('auth_user', cisData.auth_user);
// formData.append('user_comment', cisData.user_comment);
// formData.append('request_user', cisData.request_user);
//  formData.append('field', fieldService);
//  formData.append('value',(fieldService=="version"?cisData.value:field_id));
 const formData = {
   "ci_ids": poolRows,
"field": fieldService,
"value":(fieldService=="version"?cisData.value:field_id),
"user_comment": cisData.user_comment,
"request_user":cisData.request_user,
"auth_user": cisData.auth_user
 }
    setImportLoading(true);

    try {
      const response = await fetch(server.url + '/api/v1/cassia/cis_v2/mass_update/field', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(formData), // Enviamos el FormData con el archivo
      });
      // const data1 = await response.json();
      // console.log(data1)
      if (response.ok) {
        const data1 = await response.json();
        setResponse(data1.data)
        const keys = Object.keys(data1.data[0]);
        const r_ok=data1.data.filter(item => item.hostid_creado	 !== "").length
        const r_error=data1.data.filter(item => item.hostid_creado	 === "").length
        // console.log(r_ok,r_error)
        const values = data1.data.map(obj => Object.values(obj));

        // Unir las claves con los valores
        const result = [keys, ...values];
        if(r_ok==0){
          handleShowPopup('Error!!!',capitalizeFirstLetter((lang[languaje]['importError'])),capitalizeFirstLetter((lang[languaje]['msgImporAll'])), false)
        }else{
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),data1.message,'', true)
        }

        setFileContent(result);
        setTableData(result);
        setDisabled(true)
        setImportLoading(false);
        setBoolError(false);
        buscar_cis()
        // buscar_auths()
        // buscar_folios()
        closeImportModal()
      } else {
        const data1 = await response.json();
        setImportLoading(false);
        setBoolError(true);
        handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),data1.detail, false)
        setMsgError(data1.detail);
        throw new Error('Error en la importación');
      }
    } catch (error) {
      setImportLoading(false);
      handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),'Error interno', false)
      // setBoolError(true);
      // setMsgError('Error al importar archivo');
      // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
      console.error('Error al importar archivo:', error);
    }
  };

  useEffect(()=>{
      if(cisData.user_comment.length<5 || poolRows.length==0  ||  cisData.value==""   || cisData.request_user==cisData.auth_user){
          setDisabled(true)
      }else{
          setDisabled(false)
      }
  },[cisData,fieldService,field_id])
  // Función para leer el archivo
  const handleFileChange = (e) => {
    setResponse([])
    const file = e.target.files[0];
    setFile(file)
    importFunction(file,setFileContent,setTableData)
  };
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    // setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  // Renderizar la tabla
  const renderTable = () => { 
    if (!dataList.length) return null;

    return (
      //         <div className="cont-table-portafolio border-table" style={{overflow:'auto'}}>
      //       <div className={"head-table-portafolio"+mode} style={{width: '300%'}}>
      //       <div className="compact-head-table-portafolio">
      //       {tableData[0].map((header, index) => (
      //     //           <th key={index}>{header}</th
      //     <div className="field-head-table-mantenimiento field-larger"  key={index} style={{width:'25%'}}>  {header} </div>
      //             ))}
      //         </div>
      //       </div>
      //       <div className="body-table-portafolio" style={{overflowY:'auto',width: '300%'}}>
      //       {tableData.slice(1).map((row, rowIndex) => (
      //          <div
      //          className={"row-table-portafolio"+mode}
      //          key={rowIndex}
      //          style={{height:'40px'}}
      //        >
      //           {row.map((cell, cellIndex) => (
      //             (row.length>22)?

      //    <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)',color:((row[row.length-1]=="")?'red':'var(--green)')}} key={cellIndex}>
      //    {cell}
      //  </div>:
      //  <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
      // {cell}
      // </div>
      //               ))}

      //        </div>

      //           ))}
      //       </div>
      //     </div>
      <>
        <div className='head-cis'>
         <div className='title-cis'>
                     <Search
                         searchResults={searchResults}
                         setSearchResults={setSearchResults}
                         searchTerm={searchTerm}
                         setSearchTerm={setSearchTerm}
                         onSearch={handleSearch}
                         dataObject={tableData.slice(1)}
                         setDataObject={setDataUsers}
                         searchResult={searchResult}
                         setSearchResult={setSearchResult}
                         languaje={languaje}
                       />
               <div className={"cont-result-registers"+mode}>
              
                       <p style={{  textAlign: "center" }}>
                         &nbsp;
                         {"Registros Seleccionados (" +
                           dataList.length +
                           ") " 
                           }
                       </p> 
               </div>
              
                     </div>
                     
                 </div>
        <div className='cont-cis'>
        <>
  <div className="main-panel-cis">
  <div className="compact-content-portafolio">
  {/* <div className={"content-portafolio-head"+mode}>
    
          </div> */}
    <div className="content-portafolio">
      <div className="cont-portafolio-table">
        <div className="content-card-portafolio" id="content">
           <div className="cont-table-portafolio border-table" style={{overflow:'auto',height:'100%'}}>
   <div className={"head-table-portafolio"+mode} style={{width: '100%'}}>
  <div className="compact-head-table-portafolio">
   <div className="field-head-table-cis field-medium"style={{width:'15%'}}>CI-ID</div>
           <div className="field-head-table-cis field-medium"style={{width:'15%'}}>Host IP</div>
           {/* <div className="field-head-table-cis field-larger">{capitalizeFirstLetter(lang[languaje]['tecnologia'])}</div> */}
           <div className="field-head-table-cis field-larger" style={{width:'30%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])}</div>
   <div className="field-head-table-cis field-larger" style={{width:'20%'}}>{'Valor anterior'}</div>
   <div className="field-head-table-cis field-larger" style={{width:'20%'}}>{'Nuevo valor'}</div>
   </div>
  </div>
  <div className="body-table-portafolio" style={{overflowY:'auto',width: '100%'}}>
  {dataList
        .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
        .map((elemento, indice) => (
          <div
            className={"row-table-portafolio"+mode+" tooltip-container"}
            key={indice}
  //           onClick={() => 
  //             cisSelectRow(elemento)
  //             // view(elemento)
  //           }
  //            onMouseMove={handleMouseMove}
  // onMouseLeave={handleMouseLeave}
          >
              <div className="field-body-table-cis field-medium" style={{width:'15%'}}>
              {elemento.folio}
            </div>
            <div className="field-body-table-cis field-medium" style={{width:'15%'}}>
              {elemento.ip}
            </div>
            {/* <div className='field-body-table-cis field-larger'>
            {elemento.name.slice(0,35)}...
          </div> */}
            <div className="field-body-table-cis field-larger" style={{width:'30%'}}>
              {elemento.name}
            </div>
            <div className="field-body-table-cis field-larger" style={{width:'20%',color:'var(--red-alert)'}}>
              {elemento[atributoChange]}
            </div>
            <div className="field-body-table-cis field-larger" style={{width:'20%',color:'var(--green)'}}>
              {valueText}
            </div>
          </div>
          ))
            }
  {/* {dataList.map((row, rowIndex) => (
     <div
     className={"row-table-portafolio"+mode}
     key={rowIndex}
     style={{height:'40px'}}
   >
      {row.map((cell, cellIndex) => (
        (row.length>17)?
        
<div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)',color:((row[row.length-6]=="Error")?'red':'var(--green)')}} key={cellIndex}>
{cell}
</div>:
<div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
{cell==""?"N/A":cell}
</div>
          ))}
     
   </div>

      ))} */}
  </div>
</div>
        </div>
      </div>

      </div>
      <div className={"content-portafolio-footer"+mode}>
      <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
        
        
      </div>  
      <div className="cont-display-paginador">
                <Paginador  pages={pages}
                            pageActual={pageActual}
                            setPageActual={setPageActual}
                            mode={mode}></Paginador>
      </div>
      <div className="cont-display-paginador">
        <div className={"cont-half-display-paginador"+mode}>
                  
        <div>
  <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
  <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
    <option value={10}>10</option>
    <option value={50} >50</option>
    <option value={100}>100</option>
    <option value={500}>500</option>
    <option value={1000}>1000</option>
  </select>

  
</div>
        </div>
        <div className={"cont-half-display-paginador"+mode}>
        <p style={{  textAlign: "center" }}>
                        &nbsp;
                        {"(" +
                    (startLimit + 1) +
                    " - " +
                    (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                      ?  parseInt(pageActual ) * parseInt(limitList)
                      : dataList.length) +
                    ")  "+lang[languaje]['de']+" " +
                    dataList.length +
                    " "+lang[languaje]['resultados']}
                  </p>
              
        </div>
      </div>  
                
    </div>
    </div>
  </div>
  
</>
            
        </div>
      </>
    );
  };

  const handleChange=(e)=>{
    const {name,value}=e.target

    setCisData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const handleTextAreaChange = (event) => {
    setCisData((prevState)=>{
        return {
            ...prevState,
            ['user_comment']:event.target.value
        }
        
    })
  };
  const [atributoChange,setAtributoChange]=useState('')
  const changeOption=(option,index)=>{
    setField_id("")
    setCisData((prevState)=>{
      return {
          ...prevState,
          ['value']:0
      }
      
  })
    setFieldService(option.value)

    switch(option.value){
      case 'location_id':
        setAtributoChange('location')
        setTitleOption('Municipio')
        setDataOptions(location_catalog.data.data)
        break;
      case 'brand_id':
        setAtributoChange('brand')
        setTitleOption('Marcas')
        setDataOptions(brands_catalog.data.data)
        break;
      case 'ci_group_id':
        setAtributoChange('subgroup_name')
        setTitleOption('groups_catalog')
        const subgrupos = groups_catalog.data.data
.filter(item => item.type === "SUBGRUPO")
.map(item => ({
  ...item,
  name: `${item.name} (${item.parent_name})`
}));
        setDataOptions(subgrupos)
        break;
      case 'service_id':
        setAtributoChange('service')
        setTitleOption('services_catalog')
        setDataOptions(services_catalog.data.data)
        break;
      case 'model_id':
        setAtributoChange('model')
        setTitleOption('Marcas')
        setDataOptions(models_catalog.data.data)
        break;
         
      default:{}
        setTitleOption('')
        setDataOptions()

    }
  }

  const changeOptionValue=(option,index)=>{
  setField_id(option.value)  
    
  }
  const [loadingFieldOptions,setLoadingFieldOptions]=useState(false)
  useEffect(()=>{
    setLoadingFieldOptions(true)
    setTimeout(()=>{
      setLoadingFieldOptions(false) },500)
    },[dataOptions])
  const reqField=()=>{
return(
<p className='reqField-gs'>
 *
</p>
)
}
  const changeOptionUser=(option,index)=>{
      
         setCisData((prevState)=>{
                return {
                    ...prevState,
                    [option.filter]:option.label
                }
                
            })
          }

  const [valueText,setValueText]=useState('')

  const changeOptionID=(option,index)=>{
    setValueText(option.label)
    setField_id(option.value) 
       setCisData((prevState)=>{
              return {
                  ...prevState,
                  [option.filter]:option.value
              }
              
          })
          
  }

  const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  function openAddHostModal() {
      
    //   console.log('open')
      setAddHostModalOpen(true);
    }

  function closeAddHostModal() {
    
      setAddHostModalOpen(false);
  }
  const {
    request_user,user_comment,value,
    auth_user}=cisData;
  return(
    <>
      <div className="modal-GS-content">
          <div className='card-modal-gs modal-verificate'>
              {/* <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                      {lang[languaje]['actualizar'].toUpperCase()+' '+lang[languaje]['datos'].toUpperCase()}
                  </div>
              </div> */}
              <div className='content-card-modal-gs' style={{overflow:'auto'}} >
              
                  <div className="cont-import-GS-box"> 
                    <div className='row-cont-input-file'>
                          <div style={{width:'80%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>
                             <div className="cont-msg-alert-confirm-action" style={{height:'100%'}}>
                          <div className="compact-msg-alert-confirm-action">
                              <img  className='icon-msg-alert' src={"/iconos/warning.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                              <div className="msg-alert-txt-confirm-action">
                              {'Para la actualización masiva de CI’s, puede seleccionar registros de configuración desde la tabla de la vista principal o dar clic en el botón “Seleccionar CI’s”. En la parte inferior se mostrará en rojo el campo a actualizar y en verde el nuevo valor que tomará.'}

                                 
                              </div>
                          </div>
                          
                      </div>
                              {/* {'Para la importación masiva interna es necesario seleccionar 1 o mas dispositivos previamente registrados. Esta acción le creara un registro de configuración para cada dispositivo seleccionado y las modificaciones que se les realizen se veran afectadas directamente en la tabla de dispositivos'} */}
                          </div>
                          <div style={{width:'20%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>
                             <Action disabled={false} origen='Azul' titulo={'Seleccionar CI´s'}  action={openAddHostModal}/>
                          </div>
                      </div>
                      <div className='row-cont-input-file'>
                          <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-med)'}}>
                            
                              {"("+poolRows.length+")  Dispositivos seleccionados para importar"}
                          </div>
                          
                      </div>
                      {/* <div className='row-cont-input-file'>
                          {
                              (importLoading)?<div className='txtCantData'>
                              {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])+'...'}
                      </div>:
                              <div className="file-input-container">
                              <input 
                              accept=".json,.csv,.xlsx"
                                  type="file" 
                                  ref={fileInputRef} 
                                  style={{ display: 'none' }} 
                                  onChange={ handleFileChange}
                              />
                              <button className="custom-file-button" onClick={handleFileClick}>
                                 {capitalizeFirstLetter(lang[languaje]['selectFile'])}
                              </button>
    
                              <span id="file-name">
                                  {(fileInputRef.current?.files[0]==undefined)?capitalizeFirstLetter(lang[languaje]['sinArchivo']):(fileInputRef.current?.files[0].name || capitalizeFirstLetter(lang[languaje]['sinArchivo']))}
                              </span>
                          </div>
                          }
                          <div className="cont-buttons-panel" style={{right:'0%', width:'15%', top:'0%'}}>
                
        {loadingDownload?
                <LoadSimple></LoadSimple>:
                <Action
                  disabled={false}
                  origen="Green"
                  titulo={" "+'descargar plantilla'}
                  action={handledownloadDocClick}
                />}
            </div>
                      </div> */}
                      <div className='row-cont-input-file' style={{height:'70%'}}> 
                         <div className={"compact-body-step-modal "}>
                          <div className="row-form-modal">
                  <div className="colum-form-modal">
                      {(field_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                      <InputForm optionDefault={0} type='selector' endpoint='field_option'msgError={''}  error={false} changeOption={changeOption}  attr={'attr'} titulo={'Campo a actualizar'}  text={fieldService} loading={field_catalog.loading} data={field_catalog.data.data}  placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true}/>
                      }
                      </div>
                <div className="colum-form-modal">
                      {(fieldService==="version")? <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'value'} titulo={'Nuevo valor'} text={cisData.value} placeHolder={''} disabled={false} isRequired={true}/>:(users_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                     (loadingFieldOptions.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                      <InputForm  key={fieldService} optionDefault={0} type='selector' endpoint={titleOption} msgError={'false'} error={false} changeOption={changeOptionID}  attr={'value'} titulo={'Nuevo valor'} loading={loadingFieldOptions.loading} data={dataOptions} text={cisData.value} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={true} />
                      }
                  </div>
                </div>
                                          <div className="row-form-modal">
                  <div className="colum-form-modal">
               <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'request_user'} titulo={'Solicitante'} text={cisData.request_user} placeHolder={''} disabled={false} isRequired={true}/>

                      </div>
                <div className="colum-form-modal">
                <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'auth_user'} titulo={'Autorizador'} text={cisData.auth_user} placeHolder={''} disabled={false} isRequired={true}/>

                  </div>
                </div>
                                          
                                          
                                           <div className="row-form-modal-dobel">
                                                <InputForm type='textArea'  error={false} handleInputChange={handleChange}  attr={'user_comment'} titulo={'Comentarios'} text={cisData.user_comment} placeHolder={'Agregar comentarios'} disabled={false} isRequired={cisData.user_comment.length<5} coment={'(minimo 5 caracteres)'}/>
                        
                                          </div>
                                         
                                        </div>
                        {/* <div className="form-GS-box">
                          <div className="user-box-GS" style={{height:'20%'}}>
                                      {
                                          (field_catalog.loading)?'. . .':
                                          <SelectorAdmin placeholder={'Seleccionar tecnología...'} opGeneral={true} txtOpGen={''}  opt_de={0} origen={'Admin'} data={field_catalog.data.data} loading={field_catalog.loading}  titulo='field_option' selectFunction={changeOption} index={0}></SelectorAdmin>

                                      }
                                 
                                      <label className='label-GS' style={{height:'10%'}}>{"Campo a actualizar"}</label> 
                                     
                                  </div>
                                  <div className="user-box-GS" style={{height:'20%'}}>
                                      {
                                        (fieldService==="version")?<>
                                        <input  name="value"  type="text" value={value}
                                  onChange={handleChange} />
                                      
                                      
                                        </>: (loadingFieldOptions)?'. . .':
                                        <SelectorAdmin placeholder={'Seleccionar Campo...'} opGeneral={true} txtOpGen={''}  opt_de={field_id} origen={'Admin'} data={dataOptions} loading={loadingFieldOptions}  titulo={titleOption} selectFunction={changeOptionValue} index={0}></SelectorAdmin>


                                      }
                                  <label className='label-GS' style={{height:'10%'}}>{"Nuevo valor"}</label> 
                                      
                                  </div>
                          <div className="user-box-GS" style={{height:'20%'}}>
                                      
                                  <input  name="request_user"  type="text" value={request_user}
                                  onChange={handleChange} />
                                      <label className='label-GS' style={{height:'10%'}}>{"Solicitante"}</label> 
                                      {
                                          // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                      }
                                      
                                  </div>
                                   <div className="user-box-GS" style={{height:'20%'}}>
                                     
                                  <input  name="auth_user"  type="text" value={auth_user}
                                  onChange={handleChange} />
                                      <label className='label-GS' style={{height:'10%'}}>{"Autorizador"}</label> 
                                      {
                                          // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                      }
                                      
                                  </div>
                                  <div className="user-box-GS" style={{height:'20%'}}>
              
                <textarea maxlength="2000" style={{background:'background: var(--white-color)',position:'relative',resize:'none',width:'100%'}} id="nota" name="nota" className="CmtAuth" rows="3" cols="15" value={user_comment}  onChange={handleTextAreaChange}></textarea>
                                      
                                      <label className='lblCmtAuth' style={{display:'flex'}}>{'Comentarios'}{(user_comment==""|| user_comment.length<4)?reqField():''}</label> 
                              <label className='lblCmtAuth' style={{ left:'20%',color:'var(--txt-color)'}}>{'(minmo 3 caracteres)'}</label> 
                              </div>
                          </div> */}
                      </div>
                      <div className='row-cont-input-table' >
                      
    
    
      {dataList.length > 0? renderTable() : <div className="cont-table-portafolio border-table msgImport"><p>{'Seleccione almenos una configuracion para actualizar'}.</p></div>}
    
                      <div className='row-cont-input-file' style={{overflow:'auto',justifyContent:'center'}}>
                              {((boolError)?
                              
                          <div style={{width:'80%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>
                             <div className="cont-msg-alert-confirm-action" style={{height:'100%'}}>
                          <div className="compact-msg-alert-confirm-action" style={{background:'rgba(255, 166, 156, 0.59)',borderColor:'rgba(191, 18, 0, 0.59)'}}>
                              <img  className='icon-msg-alert' src={"/iconos/cancel.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                              <div className="msg-alert-txt-confirm-action">
                              {msgError}

                                 
                              </div>
                          </div>
                          
                      </div>
                          </div>
                          
                     
                              :
                                  (tableData.length==0)?'':
                                      ((response.length==0)?
                                          capitalizeFirstLetter(lang[languaje]['registrosCargar'])+': '+(tableData.length-1):
                                              <>
                                                  <div style={{color:'var(--green)'}}>{capitalizeFirstLetter(lang[languaje]['registrosCorrectos'])+':'+response.filter(item => item.status	 !== "Error").length}</div> &nbsp;&nbsp;&nbsp;
                                                  <div style={{color:'red'}}>{capitalizeFirstLetter(lang[languaje]['registrosIncorrectos'])+':'+response.filter(item => item.status	 === "Error").length}</div>
                                              </>
                                              ))}
                      </div>
                      </div>
                      <div className='row-cont-input-buttons'>
                      {(importLoading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%',width:'100%'}}><LoadSimple></LoadSimple></div>:
                      (
                      <>
                      <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(((response.length==0)?lang[languaje]['cancelar']:lang[languaje]['cerrar']))}  action={closeImportModal}/>
                      <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['actualizar'])}  action={handleImport}/>
                      </>
                      )
                      }
                      </div>           
                  </div>
              </div>
              </div>
      </div>
      <Modal
      isOpen={addHostModalOpen}
      // isOpen={true}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closeAddHostModal}
      style={addHostModalStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalAddCIs 
                     setPoolObjectRows={setPoolObjectRows} 
    setPoolRows={setPoolRows}
    poolObjectRows={poolObjectRows}
    
   datacis={datacis}
   poolRows={poolRows} server={server} handleShowPopup={handleShowPopup}    languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalAddCIs>
  </Modal>
  </>
  )
}

export default UpdateCisTable